import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import storage from "../hooks/storage";

dayjs.extend(utc);

// Mirrors agent portal's `LOCAL_STORAGE_KEYS.DOMAIN_CONFIGURATION`
// (Blitzz_Agent/src/constants/Constants.js:456) so both apps share the same
// cache shape/key.
export const DOMAIN_CONFIG_STORAGE_KEY = "domainConfiguration";
export const DOMAIN_CONFIG_CHANGED_EVENT = "domainConfigChanged";

// Handles both `fetch`'s `Headers` object and the plain object returned by
// ZAF's `zafClient.request`.
const readHeader = (headers, name) => {
  if (!headers) return null;
  if (typeof headers.get === "function") return headers.get(name);
  return (
    headers[name] ||
    headers[name.toLowerCase()] ||
    headers[name.toUpperCase()] ||
    null
  );
};

// Port of agent portal's `checkConfigAPIcall`
// (Blitzz_Agent/src/shared/utility.js:590). Returns true only when both
// timestamps exist AND the server value is newer than the cached one.
export const checkConfigAPIcall = (modifiedDate, storedDate) => {
  if (!modifiedDate || !storedDate) return false;
  return dayjs.utc(modifiedDate).isAfter(dayjs.utc(storedDate));
};

// Call from every Blitzz API response handler. Reads the SA-signalled
// `configurationmodifiedat` header, compares to cache, and dispatches
// `domainConfigChanged` when the server value is newer. TenantConfigContext
// listens for the event and does the actual refetch.
export const maybeRefreshDomainConfig = (headers) => {
  const modifiedAt = readHeader(headers, "configurationmodifiedat");
  if (!modifiedAt) return;
  const cached = storage.get(DOMAIN_CONFIG_STORAGE_KEY);
  if (!checkConfigAPIcall(modifiedAt, cached?.configurationmodifiedat)) return;
  window.dispatchEvent(
    new CustomEvent(DOMAIN_CONFIG_CHANGED_EVENT, { detail: { modifiedAt } })
  );
};
